export const sanitizePlaceQuery = (query) => {
  if (!query || typeof query !== "string") return "";
  const withoutTags = query.replace(/<[^>]*>/g, "");
  const trimmed = withoutTags.trim();
  return trimmed.slice(0, 100);
};

export const sanitizePlaceLabel = (label) => {
  if (!label || typeof label !== "string") return "";
  const withoutTags = label.replace(/<[^>]*>/g, "");
  return withoutTags.trim();
};

const isValidLonLat = (lon, lat) => {
  if (typeof lon !== "number" || typeof lat !== "number") return false;
  if (!Number.isFinite(lon) || !Number.isFinite(lat)) return false;
  return lon >= -180.0 && lon <= 180.0 && lat >= -85.0511 && lat <= 85.0511;
};

export const parseKartverketResponse = (json) => {
  if (!json || !Array.isArray(json.navn)) {
    return [];
  }

  const results = [];
  for (const item of json.navn) {
    const pt = item.representasjonspunkt;
    const lon = pt?.øst;
    const lat = pt?.nord;
    if (!isValidLonLat(lon, lat)) continue;

    const title = sanitizePlaceLabel(item.skrivemåte || "");
    if (!title) continue;

    const kommune = item.kommuner?.[0]?.kommunenavn || "";
    const fylke = item.fylker?.[0]?.fylkesnavn || "";
    const type = item.navneobjekttype || "";
    const subtitle = [type, kommune, fylke].filter(Boolean).join(", ");

    results.push({
      id: String(item.stedsnummer || `kv-${results.length}`),
      title,
      subtitle,
      coordinate: [lon, lat],
      source: "kartverket",
    });
  }

  return results;
};

export const parseNominatimResponse = (json) => {
  if (!Array.isArray(json)) {
    return [];
  }

  const results = [];
  for (const item of json) {
    const lon = parseFloat(item.lon);
    const lat = parseFloat(item.lat);
    if (!isValidLonLat(lon, lat)) continue;

    const title = sanitizePlaceLabel(item.name || item.display_name?.split(",")[0] || "");
    const subtitle = sanitizePlaceLabel(item.display_name || "");
    if (!title) continue;

    results.push({
      id: String(item.place_id || `nom-${results.length}`),
      title,
      subtitle,
      coordinate: [lon, lat],
      source: "nominatim",
    });
  }

  return results;
};

const GENERIC_ERROR_MESSAGE = "Kunne ikke slå opp stedsnavn, prøv igjen eller klikk i kartet";

export const searchPlaces = async (query, { fetchImpl = fetch } = {}) => {
  const cleanQuery = sanitizePlaceQuery(query);
  if (!cleanQuery) {
    return { results: [], error: null };
  }

  try {
    const kvUrl = `https://ws.geonorge.no/stedsnavn/v1/navn?sok=${encodeURIComponent(cleanQuery)}&utkoordsys=4258&antPerSide=10`;
    const res = await fetchImpl(kvUrl);
    if (!res.ok) {
      return { results: [], error: GENERIC_ERROR_MESSAGE };
    }

    const data = await res.json();
    let results = parseKartverketResponse(data);

    if (results.length === 0) {
      const nomUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(cleanQuery)}&limit=10`;
      const nomRes = await fetchImpl(nomUrl);
      if (nomRes.ok) {
        const nomData = await nomRes.json();
        results = parseNominatimResponse(nomData);
      }
    }

    return { results, error: null };
  } catch {
    return { results: [], error: GENERIC_ERROR_MESSAGE };
  }
};
